import { render } from "./MainNavigation.vue?vue&type=template&id=50736441"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=50736441&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__